import { JsonObject, JsonProperty } from 'json2typescript'
import DateConverter from '@/converters/DateConverter'
import ProductEnumConverter from '@/converters/ProductEnumConverter'
import QuoteStatusEnumConverter from '@/converters/QuoteStatusEnumConverter'
import ProductEnum from '../enums/ProductEnum'
import QuoteStatus from '../enums/QuoteStatusEnum'
import SummaryItem from './SummaryItem'

@JsonObject('QuoteSummary')
export default class QuoteSummary {
  @JsonProperty('quoteReference', String)
  quoteReference = ''

  @JsonProperty('product', ProductEnumConverter)
  product: ProductEnum = ProductEnum.modernCar

  @JsonProperty('status', QuoteStatusEnumConverter)
  status: QuoteStatus = QuoteStatus.quoted

  @JsonProperty('isActive', Boolean)
  isActive = false

  @JsonProperty('quoteCreationDate', DateConverter)
  quoteCreationDate: Date = new Date()

  @JsonProperty('effectiveDate', DateConverter)
  effectiveDate: Date = new Date()

  @JsonProperty('calculatedTotalPayable', Number)
  calculatedTotalPayable = 0

  @JsonProperty('summaryItems', [SummaryItem])
  summaryItems: SummaryItem[] = []
}
